import { clearOldInteractionsEntries, STORAGE_KEYS } from '@/services/interactions-tracker';

const storageManager = App.es6.shared.storage_manager().init('local');

export function trackSearchVisit(seen, clicked) {
  const today = window.dayjs().format('YYYY-MM-DD');

  const storage = storageManager.get(STORAGE_KEYS.SEARCH) ?? '{}';
  const data = JSON.parse(storage);

  data[today] = data[today] ?? { seen: [], clicked: [] };

  data[today].seen.push(...seen);
  data[today].clicked.push(...clicked);
  storageManager.set(STORAGE_KEYS.SEARCH, JSON.stringify(data));
}

export function clearOldSearchInteractionsEntries() {
  clearOldInteractionsEntries(STORAGE_KEYS.SEARCH);
}
